import {
    useRef,
    useEffect,
    useState,
} from 'react';

const useIntersectionObserver = ({
    elementRef,
    threshold = 0,
    root = null,
    rootMargin = '0%',
    disconnectOnIntersect = false,
}) => {

    const observer = useRef(null);
    const [
        entry,
        setEntry,
    ] = useState();

    useEffect(() => {

        const node = elementRef?.current;
        const isSupported = typeof window !== `undefined` && !!window.IntersectionObserver;

        if (!isSupported || !node) {

            return;

        }

        if (observer.current) {

            observer.current.disconnect();

        }

        observer.current = new IntersectionObserver(
            ([entry], observer) => {

                setEntry(entry);

                if (
                    entry.isIntersecting
                    && disconnectOnIntersect
                ) {

                    observer.disconnect();

                }

            }, {
                threshold,
                root,
                rootMargin,
            }
        );

        const { current: currentObserver } = observer;

        currentObserver.observe(node);

        return () => {

            currentObserver.disconnect();

        };

    }, [
        elementRef,
        threshold,
        root,
        rootMargin,
        disconnectOnIntersect,
    ]);

    return {
        isVisible: !!entry?.isIntersecting,
        entry,
    };

};

export default useIntersectionObserver;
